import { render, staticRenderFns } from "./Keycopy.vue?vue&type=template&id=7c6553ba&scoped=true"
import script from "./Keycopy.vue?vue&type=script&lang=js"
export * from "./Keycopy.vue?vue&type=script&lang=js"
import style0 from "./Keycopy.vue?vue&type=style&index=0&id=7c6553ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6553ba",
  null
  
)

export default component.exports